webpackJsonp([211409413883064],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MontanaImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MontanaLocation = function (_React$Component) {
	  _inherits(MontanaLocation, _React$Component);
	
	  function MontanaLocation() {
	    _classCallCheck(this, MontanaLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MontanaLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Montana' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Govt\u2014State + Local',
	        title: 'Big Sky Country',
	        story: 'We put our 1.25 million individual members to work, encouraging them to take action on issues related to bike riding in their communities. In 2017 we sent action alerts to our members from coast to coast. One of our signature victories came when we helped defeat a bad bike bill in Montana that would have required out-of-state bikes riders to purchase a $25 sticker for each bike they ride in the state.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Montana',
	        alt: 'Montana Outdoor Scene',
	        sizes: this.props.data.montanaImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Charlotte, NC',
	        prevLocationPath: 'charlotte',
	        prevLocationImgPath: this.props.data.montanaPrevImage,
	        nextLocationName: 'Washington, DC',
	        nextLocationPath: 'washington-dc',
	        nextLocationImgPath: this.props.data.montanaNextImage
	      })
	    );
	  };
	
	  return MontanaLocation;
	}(_react2.default.Component);
	
	exports.default = MontanaLocation;
	var MontanaImageQuery = exports.MontanaImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-montana-js-53c1a1e7c461df643db4.js